// libraries
import { Spinner } from 'react-bootstrap';

// styles
import { LoadingContainer } from '../styles';

interface AutoLoginLoaderProps {
  title: string;
  subtitle: string;
}

export const AutoLoginLoader = ({ title, subtitle }: AutoLoginLoaderProps) => {
  return (
    <LoadingContainer>
      <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
      <div>
        <div className="loading-title">{title}</div>
        <div className="loading-subtitle">{subtitle}</div>
      </div>
    </LoadingContainer>
  );
};
